
export const professional_experience = [
    {
      title: "Founder & Principal Solutions Architect",
      company: "Watkins Labs",
      date: "January 2024 – Present",
      location: "Sugar Hill, GA",
      description: "Provides specialized consulting for corporations managing legacy infrastructure and modernization challenges. Develops hybrid solutions bridging decades-old systems with contemporary platforms.",
      achievements: [
        "Modernized DOS, COBOL, and end-of-life systems for continued business operation",
        "Built custom frameworks enabling seamless compatibility between legacy and modern environments",
        "Delivered sustainable support for systems with minimal vendor backing",
        "Transitioned VMware environments to cost-effective alternatives while maintaining operational continuity",
        "Designed and deployed multi-GPU workloads in custom environments for AI-driven client applications"
      ],
      tech: ["Python", "PHP", "Perl", "COBOL", "C", "C++", "Linux", "VMware", "Nvidia", "CUDA"]
    },
    {
      title: "Senior Site Reliability Engineer",
      company: "IBM Financial Services Division", 
      date: "July 2021 – January 2024",
      location: "Hybrid/Travel",
      description: "Architected and delivered enterprise solutions for top-tier financial institutions while supporting strategic sales initiatives. Collaborated directly with IBM WatsonX team on AI implementations for banking clients.",
      achievements: [
        "Designed AWS-based infrastructures integrating IBM MQ, WatsonAIOps, and large language models",
        "Developed proof-of-concept systems for document analysis and process automation in regulated environments",
        "Optimized OpenShift, monitoring tools, and multi-cloud architectures for financial services",
        "Served as technical liaison between engineering teams and enterprise stakeholders",
        "Architected multi-GPU computing environments for enterprise AI workloads in financial services"
      ],
      tech: ["AWS", "OpenShift", "Kubernetes", "IBM WatsonX", "Python", "Instana", "Turbonomic", "Nvidia", "CUDA"]
    },
    {
      title: "Principal Site Reliability Engineer",
      company: "E*TRADE",
      date: "June 2018 – February 2021", 
      location: "Alpharetta, GA",
      description: "Enhanced infrastructure reliability and operational efficiency across enterprise trading platform supporting millions of users. Led SRE adoption across multiple business units.",
      achievements: [
        "Automated management of 20,000+ virtual machines across VMware and AWS environments",
        "Migrated legacy distributed systems to cloud-native architectures",
        "Implemented comprehensive monitoring, alerting, and incident response procedures",
        "Architected DDB, an open-source in-memory database enabling SQL-like queries on flat files"
      ],
      tech: ["Terraform", "Ansible", "Kubernetes", "Python", "VMware", "AWS", "Prometheus"]
    },
  
    {
      title: "Senior Software Developer",
      company: "Pitney Bowes",
      date: "January 2017 – February 2018",
      location: "Seattle, WA",
      description: "Developed enterprise shipping platform components serving global logistics operations.",
      achievements: [
        "Designed microservices for worldwide shipping rate processing and optimization",
        "Built specialized reporting and barcode management systems",
        "Implemented Git version control and conducted technical training"
      ],
      tech: ["C#", "ASP.NET", "JavaScript", "MSSQL", "AWS S3/EC2"]
    },
    {
      title: "Founder & Principal Solutions Architect", 
      company: "DataModerated",
      date: "July 2001 – December 2016",
      location: "Multi-location",
      description: "Led technical consulting practice specializing in enterprise system migrations and infrastructure modernization. Managed team of engineers while maintaining hands-on technical involvement.",
      achievements: [
        "Delivered architecture and implementation services for complex business systems",
        "Successfully transitioned multiple legacy environments to modern platforms",
        "Developed numerous EDI and API solutions for seamless business process automation",
        "Managed technical staff while maintaining direct client relationships"
      ],
      tech: ["C", "C++", "C#", "Python", "Perl", "Multiple database platforms", "VMware", "KVM"]
    }
  ];